module.exports = __webpack_public_path__ + "static/media/syrq.f85f17da.png";